import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Row, Col, Card} from 'antd';

import * as actions from '../redux/actions/index';
import LineChart from "../charts/LineChart";

import './StateCard.css';

class StateTimelineCard extends Component {
  render() {
    const onClick = (fips, year) => {
      this.props.actions.selectCounty(fips);
      this.props.actions.selectYear(year);
    };

    return (
      <Card className="StateComboCard" noHovering={true} loading={this.props.loading}>
        <Row gutter={10}>
          <Col xs={24} md={12}>
            <h2 className="subtitle">
              <svg width={14} height={8}><rect width={8} height={8} rx={4} ry={4} fill="#e04040"></rect></svg>
              {this.props.xLabel} by County over Time
            </h2>
            <LineChart
              type="x"
              dimG={this.props.idField}
              dimY={this.props.xField}
              titleY={this.props.xLabel}
              year={this.props.year}
              selected={this.props.selectedFips}
              data={this.props.data}
              onClick={onClick}
            />
          </Col>
          <Col xs={24} md={12}>
            <h2 className="subtitle">
              <svg width={14} height={8}><rect width={8} height={8} rx={4} ry={4} fill="#0f8ee9"></rect></svg>
              {this.props.yLabel} by County over Time
            </h2>
            <LineChart
              type="y"
              dimG={this.props.idField}
              dimY={this.props.yField}
              titleY={this.props.yLabel}
              year={this.props.year}
              selected={this.props.selectedFips}
              data={this.props.data}
              onClick={onClick}
            />
          </Col>
        </Row>
      </Card>
    );
  }
}

function mapStoreToProps(store, props) {
  return {
    loading: store.counties.loading || store.dimensions.loading,
    data: store.counties.data,
    dict: store.counties.dict,
    idField: store.dimensions.countyKey,
    selectedFips: store.counties.selected.fips,
    xField: store.dimensions.xField,
    yField: store.dimensions.yField,
    xLabel: store.dimensions.xLabel,
    yLabel: store.dimensions.yLabel,
    xDesc: store.dimensions.xDesc,
    yDesc: store.dimensions.yDesc,
    year: store.dimensions.year
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStoreToProps, mapDispatchToProps)(StateTimelineCard);



// WEBPACK FOOTER //
// ./src/containers/StateTimelineCard.js